



































import { defineComponent, computed } from '@nuxtjs/composition-api'
import { injectProductCategory } from '~/composables/product/useProductCategory'

export default defineComponent({
  name: 'ProductListerCategoryTiles',

  setup() {
    const { category } = injectProductCategory()

    const subCategories = computed(() => category.value?.children ?? [])

    return {
      subCategories,
    }
  },
})
